// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_dp-3";
export var flatBottomCorners = "_dp-5";
export var productImage = "_dp-0";
export var quantityContainer = "_dp-2";
export var quantityHeader = "_dp-6";
export var tooltip = "_dp-1";
export var wrapAndEllipsesOverflow = "_dp-4";